import styled from "styled-components"

export const HeaderWrapper = styled.header`
  min-height: 700px;
  position: relative;
`

export const BackImage = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;

  /* ::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: -webkit-linear-gradient(
      top,
      rgb(192 183 183 / 4%) 0%,
      rgb(8 8 8 / 72%) 30%,
      rgb(45 45 45 / 39%) 100%
    );
  } */
`

export const MainContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    justify-content: left;
  }
`

export const TextAndContent = styled.div`
  text-align: center;

  @media (max-width: 992px) {
    padding: 0 15px 0 15px;
  }

  > h3 {
    margin-bottom: 15px;
    color: var(--white);
    font-size: 15px;
    font-family: "Oswald", sans-serif;
    letter-spacing: 2px;
  }
  span {
    color: var(--white);
  }
`

export const MenuContent = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  color: var(--white);
  /* backdrop-filter: blur(2px); */
  padding: 15px 50px;
  background: hsl(0deg 0% 100% / 21%);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgb(0 0 0 / 10%);
  line-height: 20px;

  @media (max-width: 992px) {
    padding: 15px;
  }
`

export const Gradient = styled.div`
  position: absolute;
  inset: 0 0 0 0;
  background: -webkit-linear-gradient(
    top,
    rgb(76 73 73 / 43%) 0%,
    rgb(8 8 8 / 72%) 30%,
    rgb(45 45 45 / 39%) 100%
  );
`
